import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { getFederalSubjects } from "sources/map";

const config = {
    name: {
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    regionIds: {
        label: "Регионы",
        inputProps: { name: "regionIds" },
        validators: [requiredField],
        required: true,
        isSelect: true,
        isMulti: true,
        url: getFederalSubjects,
        propName: "name",
        minimumInputLength: 2,
        menuPortalTarget: document.body,
        styles: {
            valueContainer: (styles) => ({ ...styles, lineHeight: "18px" }),
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
